<template>
	<v-container grid-list-md>
		<ValidationObserver ref="obs" v-slot="{ invalid }">
			<v-form>
				<v-card>
					<v-card-title primary-title>
						<v-btn
							icon
							@click="
								$inertia.visit(
									$route('central.payment_methods.index')
								)
							"
							><v-icon>mdi-arrow-left</v-icon></v-btn
						>
						{{ $t("title.create_payment_method") }}
					</v-card-title>
					<v-divider></v-divider>
					<v-card-text>
						<PaymentMethodForm v-model="item"></PaymentMethodForm>
					</v-card-text>
					<v-divider></v-divider>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn
							color="primary"
							@click.native="submit()"
							:loading="item.processing"
							:disabled="invalid"
						>
							<v-icon left>mdi-content-save</v-icon>
							{{ $t("Save") }}
						</v-btn>
					</v-card-actions>
				</v-card>
			</v-form>
		</ValidationObserver>
	</v-container>
</template>
<script>
import PaymentMethodForm from "@Payment/forms/PaymentMethodForm.vue";
export default {
	components: {
		PaymentMethodForm,
	},
	data() {
		return {
			item: this.$inertia.form({
				code: null,
				name: {
					en: null,
					km: null,
					fr: null,
					zh: null,
				},
				description: {
					en: null,
					km: null,
					fr: null,
					zh: null,
				},
				settings: {
					delivery_module: true,
					pickup_module: true,
					dine_in_module: true,
					wallet_module: true,
					membership_module: true,
				},
			}),
		};
	},
	methods: {
		submit() {
			this.item.post(this.$route("central.payment_methods.store"));
		},
	},
};
</script>
